import SysAdminReportComponent from 'components/SysAdmin/SysAdminReportComponent/SysAdminReportComponent';
import ContainerComponent from 'components/Tool/ContainerComponent/ContainerComponent';
import Footer from 'pages/Client/Footer/Footer';
import Header from 'pages/Client/Header/Header';
import SysAdminMenu, { SysAdminMenuEnum } from 'pages/SysAdmin/SysAdminMenu/SysAdminMenu';
import './Report.css';

function Report() {
  return (
    <>
      <div className="sys-admin-report layout-full-height">
        <Header />

        <ContainerComponent className="layout-main-content">
          <>
            <SysAdminMenu selectedMenu={SysAdminMenuEnum.REPORT} />

            <SysAdminReportComponent />
          </>
        </ContainerComponent>

        <Footer />
      </div>
    </>
  );
}

export default Report;
